module.exports = __webpack_public_path__ + "img/600.5b89fded.svg";